// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__iqBkw","spin":"spinner_spin__lkMwd","grey":"spinner_grey__tozoj","white":"spinner_white___KeHS","black":"spinner_black__Mz_Fs"};